module.exports = __webpack_public_path__ + "static/media/hero_video_mobile.39010572.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/hero_video_mobile.mp4
// module id = 59
// module chunks = 0